module.exports = __webpack_public_path__ + "img/IMG-V_115625.b503d145.jpeg";